function show_delivery_pricing_chart ()
{
	var delivery_pricing_chart = document.getElementById("delivery_pricing_chart");
	if(delivery_pricing_chart.style.display == 'block')
	{
		delivery_pricing_chart.style.display = 'none';
	}else {
		delivery_pricing_chart.style.display = 'block';
	}
	return false;
}